<div>
  <mat-toolbar color="accent">
    <mat-toolbar-row>
      <button mat-button (click)="onRefresh()">
        <mat-icon aria-hidden="false" aria-label="Refresh">refresh</mat-icon>
        Refresh Release Notes
      </button>
      <button mat-button (click)="onAdd()">
        <mat-icon aria-hidden="false" aria-label="Add Release Note">add</mat-icon>
        Add Release Note
      </button>
      <span class="toolbar-spacer"></span>
      <mat-form-field color="accent">
        <input matInput placeholder="Search release notes..." [(ngModel)]="filter" (ngModelChange)="onFilter($event)" />
      </mat-form-field>
      <button mat-icon-button aria-label="Clear" *ngIf="filter" (click)="onFilter(''); filter = ''">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  @if (loading) {
    <div class="loading-container">
      <mat-spinner></mat-spinner>
      <p>Loading Release Notes...</p>
    </div>
  } @else {
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort width="100%">
      <ng-container matColumnDef="version">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Version</th>
        <td mat-cell *matCellDef="let item">{{ item.version }}</td>
      </ng-container>
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 160px">Date</th>
        <td mat-cell *matCellDef="let item" style="width: 160px">{{ item.date | date: 'yyyy-MM-dd' }}</td>
      </ng-container>
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
        <td mat-cell *matCellDef="let item">
          <span class="release-type" [ngClass]="item.type">
            <mat-icon *ngIf="item.type === 'feature'">auto_awesome</mat-icon>
            <mat-icon *ngIf="item.type === 'bugfix'">bug_report</mat-icon>
            {{ item.type | titlecase }}
          </span>
        </td>
      </ng-container>
      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Title</th>
        <td mat-cell *matCellDef="let item">{{ item.title }}</td>
      </ng-container>
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
        <td mat-cell *matCellDef="let item">{{ item.description }}</td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let item">
          <button mat-flat-button color="accent" (click)="onEdit(item)">Edit</button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>
    </table>
  }
</div>
